import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";

import routes from "routes.js";
import logo from "../assets/img/brand/logo.png";

const Auth = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-white");
    return () => document.body.classList.remove("bg-white");
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) =>
    routes.map((prop, key) =>
      prop.layout === "/auth" ? (
        <Route path={prop.path} element={prop.component} key={key} exact />
      ) : null
    );

  return (
    <div
      ref={mainContent}
      style={{
        minHeight: "100vh",
        background: "#e9edf2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          maxWidth: 960,
          minHeight: 560,
          background: "#fff",
          borderRadius: "1.5rem",
          overflow: "hidden",
          boxShadow: "0 24px 70px rgba(0,0,0,0.45)",
        }}
      >
        {/* LEFT — login form */}
        <div
          style={{
            flex: 1,
            padding: "3rem 3.25rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>
        </div>

        {/* RIGHT — brand / illustration panel (hidden on small screens) */}
        <div
          className="d-none d-md-flex"
          style={{
            flex: 1,
            background: "#e6f0fb",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2.5rem",
            textAlign: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "1rem",
              padding: "1.5rem 2rem",
              boxShadow: "0 12px 34px rgba(18,58,122,0.18)",
            }}
          >
            <img src={logo} alt="Salora Capital Limited" style={{ maxWidth: 260, width: "100%" }} />
          </div>
          <p style={{ color: "#123a7a", fontWeight: 600, marginTop: "1.75rem", maxWidth: 320, lineHeight: 1.6 }}>
            Salora Capital Limited — a Reserve Bank of India registered NBFC.
            Secure lending, repayments & collections.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Auth;
